import { BaseSessionAdapter } from '~/services/adapters/base-session.adapter';

export class CXSessionAdapter extends BaseSessionAdapter {
    loginClientPortalReactFirst = super.loginClientPortalReactFirst;
}
